import * as React from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { supabase } from "../../auth/supabaseClient";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";

function ChangePassword({ open, handleClose }) {
    const [newPassword, setNewPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');
    const [newPasswordError, setNewPasswordError] = React.useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = React.useState(false);
    const [newPasswordErrorMessage, setNewPasswordErrorMessage] = React.useState('');
    const [confirmPasswordErrorMessage, setConfirmPasswordErrorMessage] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    const handleDialogClose = () => {
        handleClose();
        setNewPassword('');
        setConfirmPassword('');
        setNewPasswordError(false);
        setConfirmPasswordError(false);
        setNewPasswordErrorMessage('');
        setConfirmPasswordErrorMessage('');
    };

    const handleNewPasswordChange = (event) => {
        const value = event.target.value;
        setNewPassword(value);
        if (value.length < 6) {
        setNewPasswordError(true);
        setNewPasswordErrorMessage('Password must be at least 6 characters long');
        } else {
        setNewPasswordError(false);
        setNewPasswordErrorMessage('');
        }
    };

    const handleConfirmPasswordChange = (event) => {
        const value = event.target.value;
        setConfirmPassword(value);
        if (value !== newPassword) {
        setConfirmPasswordError(true);
        setConfirmPasswordErrorMessage('Passwords do not match');
        } else {
        setConfirmPasswordError(false);
        setConfirmPasswordErrorMessage('');
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (newPasswordError || confirmPasswordError) return;
        setLoading(true);

        const { error } = await supabase.auth.updateUser({ password: newPassword });

        if (error) {
            setNewPasswordError(true);
            setNewPasswordErrorMessage(error.message);
        } else {
            await supabase.auth.signOut();
            handleClose();
            toast.success("Your password has been updated! Please sign in again.")
        }
        setLoading(false);
    };

    return (
        <Dialog
        fullWidth
        open={open}
        onClose={handleDialogClose}
        PaperProps={{
            component: 'form',
            onSubmit: handleSubmit,
            sx: { backgroundImage: 'none' },
        }}
        >
        <DialogTitle>Reset password</DialogTitle>
        <DialogContent
            sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
        >
            <FormControl>
            <FormLabel htmlFor="newPassword">New Password</FormLabel>
            <TextField
                autoFocus
                error={newPasswordError}
                helperText={newPasswordErrorMessage}
                name="newPassword"
                placeholder="••••••"
                type="password"
                id="newPassword"
                autoComplete="current-password"
                required
                fullWidth
                variant="outlined"
                color={newPasswordError ? 'error' : 'primary'}
                value={newPassword}
                onChange={handleNewPasswordChange}
            />
            </FormControl>
            <FormControl>
            <FormLabel htmlFor="confirmPassword">Confirm New Password</FormLabel>
            <TextField
                error={confirmPasswordError}
                helperText={confirmPasswordErrorMessage}
                name="confirmPassword"
                placeholder="••••••"
                type="password"
                id="confirmPassword"
                autoComplete="current-password"
                required
                fullWidth
                variant="outlined"
                color={confirmPasswordError ? 'error' : 'primary'}
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
            />
            </FormControl>
        </DialogContent>
        <DialogActions sx={{ pb: 3, px: 3 }}>
            <Button onClick={handleDialogClose} disabled={loading}>Cancel</Button>
            <Button variant="contained" type="submit" disabled={loading}>
            {loading ? 'Updating...' : 'Continue'}
            </Button>
        </DialogActions>
        </Dialog>
    );
}

ChangePassword.propTypes = {
    handleClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default ChangePassword;
